﻿import { FC } from 'react';
import { useRoute } from './hooks/useRoute';
import { AppRouter } from './router/Router';

export const App: FC = () => {
  const { currentPath, navigate } = useRoute();

  return <AppRouter currentPath={currentPath} onNavigate={navigate} />;
};

export default App;

